<template>
  <div>
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <label>Title (EN):</label>
        <div class="form-group">
          <input
            type="text"
            placeholder="Contract Title"
            class="form-control"
            :value="template.details.en.name"
            disabled
          />
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <label>Title (AR):</label>
        <div class="form-group">
          <input
            type="text"
            placeholder="Contract Title"
            class="form-control text-right"
            :value="template.details.ar.name"
            disabled
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <label>Country:</label>
        <div class="form-group">
          <select class="form-control" disabled>
            <option selected>{{ countryName(template.country) }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <label>Type:</label>
        <div class="form-group">
          <select id class="form-control" disabled :value="template.type">
            <option value="Occupancy Free of Charge Lease">
              Occupancy Free of Charge Lease
            </option>
            <option value="Standard Residential Lease">
              Standard Residential Lease
            </option>
            <option value="Rent Reduction Lease">Rent Reduction Lease</option>
          </select>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <label for>Description (EN)</label>
        <textarea
          cols="30"
          rows="7"
          class="form-control"
          disabled
          :value="template.details.en.description"
        ></textarea>
      </div>
      <div class="col-md-6 col-sm-12">
        <label for>Description (AR)</label>
        <textarea
          cols="30"
          rows="7"
          class="form-control text-right"
          disabled
          :value="template.details.ar.description"
        ></textarea>
      </div>
    </div>
    <div class="row" style="margin-top: 15px">
      <div class="col-md-6 col-sm-12">
        <label>Status:</label>
        <div class="form-group">
          <select class="form-control" disabled :value="template.status">
            <option value="draft">Draft</option>
            <option value="published">Published</option>
            <option value="archived">Archived</option>
          </select>
        </div>
      </div>
    </div>

    <div class="text-left my-2">
      <h6 class="text-bold-600">Terms and Conditions</h6>
    </div>
    <div>
      <div data-repeater-item v-for="(term, index) in terms" :key="index">
        <div class="row">
          <div class="col-6">
            <div class="row justify-content-between">
              <div class="col-md-8 col-sm-8 form-group">
                <label for>Term Title (EN)</label>
                <input
                  type="text"
                  class="form-control term-title-edit"
                  placeholder="Enter term title"
                  :value="term.title"
                  disabled
                />
              </div>
              <div class="col-md-12 col-sm-12 form-group">
                <label for="password">Term Description (EN)</label>
                <textarea
                  cols="30"
                  rows="5"
                  class="form-control term-description-edit"
                  placeholder="Enter term description..."
                  :value="term.description"
                  disabled
                ></textarea>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="row justify-content-between">
              <div class="col-md-8 col-sm-8 form-group">
                <label for>Term Title (AR)</label>
                <input
                  type="text"
                  class="form-control term-title-edit-ar text-right"
                  placeholder="Enter term title"
                  :value="termsAr[index].title"
                  disabled
                />
              </div>
              <div class="col-md-2 col-sm-2"></div>
              <div class="col-md-12 col-sm-12 form-group">
                <label for="password">Term Description (AR)</label>
                <textarea
                  cols="30"
                  rows="5"
                  class="form-control term-description-edit-ar text-right"
                  placeholder="Enter term description..."
                  :value="termsAr[index].description"
                  disabled
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
import { getCountryName } from "@/app-assets/js/get-countries.js";
export default {
  props: ["template"],

  data() {
    return {
      terms: [],
      termsAr: [],
    };
  },

  methods: {
    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },
  },

  mounted() {
    this.terms = this.template.terms.en;
    this.termsAr = this.template.terms.ar;
  },
};
</script>

